import Chart from "components/Dashboard/Chart";
import { useState, useEffect, useMemo } from "react";
import styles from "./DashboardPage.module.scss";
import { ChartFooter, ChartHeader } from "components/Dashboard";
import timeRecorded from "../../assets/DashboardIcons/timeRecorded.svg";
import { AmountFormat } from "components/common/formatter";
import { useDashboardData } from "services/dashboardService";
import { useCompany } from "services/companyService";

export const TimeTagetChart = ({ filters }) => {
 
  const { data: dashboardData, loading } = useDashboardData();
  const timeTarget = dashboardData?.time;

  const { categories, series } = useMemo(() => {
    if (!timeTarget?.data || !Array.isArray(timeTarget.data)) {
      return {
        categories: [],
        series: [
          { name: "Time Recorded", data: [] },
          { name: "Target", data: [] },
        ],
      };
    }

    const categories = timeTarget.data.map((item) => item.key);
    const series = [
      {
        name: "Time Recorded",
        data: timeTarget.data.map((item) => item.actual ?? 0),
      },
      { name: "Target", data: timeTarget.data.map((item) => item.target ?? 0) },
    ];

    return { categories, series };
  }, [timeTarget?.data]);

  // useEffect(() => {
  //   const newTypes = [];
  //   if (filters?.feeEarnerRef == null)
  //     newTypes.push({ label: "By Fee Earner", value: "FeeEarner" });
  //   if (filters?.appCode == null)
  //     newTypes.push({ label: "By App", value: "Application" });
  //   if (filters?.branch == null)
  //     newTypes.push({ label: "By Branch", value: "Branch" });
  //   if (filters?.month == null)
  //     newTypes.push({ label: "By Month", value: "Month" });

  //   setTypesData(newTypes);

  //   if (!newTypes.some((t) => t.value === type)) {
  //     setType("Month");
  //   }
  // }, [filters, type]);

  return (
    <div className="h-100 p-2">
      <ChartHeader
        name="Time Recorded"
        type="(Actual vs Targets)"
        param1="Time Recorded"
        param2="Target"
        icon={timeRecorded}
        color="#F9F4FF"
        duration={filters?.duration}
      />

      {loading ? (
        <div className="h-100 p-2 d-flex align-items-center justify-content-center">
          <div className="text-muted">Loading time data...</div>
        </div>
      ) : (
        <>
          <div className="d-flex p-2">
            <Chart
              series={series}
              categories={categories}
              onSeriesClick={() => {}}
            />
          </div>
          <ChartFooter param1="Time Recorded" param2="Target" data={series} />
        </>
      )}
    </div>
  );
};

export const TimeRecordedStatsCard = () => {
  const { data: dashboardData, loading } = useDashboardData();
  const {data:companyData} = useCompany();

  const timeTarget = dashboardData?.time;
  const totalActual =
    timeTarget?.data?.reduce((sum, item) => sum + item.actual, 0) || 0;
  const totalTarget =
    timeTarget?.data?.reduce((sum, item) => sum + item.target, 0) || 0;


  return (
    <div className="d-flex flex-column align-items-start mt-4 py-3 px-4">
      <div
        className={`${styles.iconContainer}`}
        style={{
          backgroundColor: "#F9F4FF",
        }}
      >
        <img src={timeRecorded} alt="time Icon" />
      </div>
      <p className="fs-md fw-semibold mt-1 mb-1" style={{ color: "#9747FF" }}>
        Time Recorded
      </p>
      {loading ? (
        <span className="text-muted">Loading...</span>
      ) : (
        <p className="fs-lg fw-bold">{companyData.baseCurrencySymbol}{AmountFormat(totalActual)}<span style={{ color: "#898989"}}> / {companyData.baseCurrencySymbol}{AmountFormat(totalTarget)}</span></p>
      )}
    </div>
  );
};
